const details = {
    name: "فروشگاه تبریز شیک مرند",
    enName: "shop",
    description: "فروشگاه تبریز شیک مرند",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "طراحی فروشگاه اینترنتی لباس",
        link: "https://barantm.com/landing/web-design-clothing"
    }
}

export default details;
